import { Link, useRouteLoaderData } from "react-router-dom";

import "./MainFooter.css";
import logoSvg from "../../../assets/logo-img.svg";
import googleIcon from "../../../assets/google-icon.svg";
import instagramIcon from "../../../assets/instagram-icon.svg";
import discordIcon from "../../../assets/discord-icon.svg";

export default function MainFooter() {
  const token = useRouteLoaderData("root");

  return (
    <>
      <footer>
        <div className="container">
          <div className="footer-wrapper">
            <div className="row-essy">
              <div className="col-essy-lg-4 col-essy-md-12">
                <div className="footer-left-wrapper">
                  <Link to="/" className="footer-logo">
                    <img src={logoSvg} alt="logo" />
                  </Link>
                  <p>
                    Pre-vetted sales engineers ready to fuel your growth. Stop
                    searching, start hiring. Pre-vetted sales engineers ready to
                    fuel your growth. Stop searching, start hiring.
                  </p>
                  <div className="social-media-footer d-flex-essy items-center-essy">
                    <a href="#" target="_blank">
                      <img src={googleIcon} alt="google-icon" />
                    </a>
                    <a href="#" target="_blank">
                      <img src={instagramIcon} alt="instagram-icon" />
                    </a>
                    <a href="#" target="_blank">
                      <img src={discordIcon} alt="discord-icon" />
                    </a>
                  </div>
                  <div className="terms-wrapper d-flex-essy">
                    <Link to="/terms-of-services">Terms of Services</Link>
                    <Link to="/privacy-policy">Privacy Policy</Link>
                  </div>
                </div>
              </div>
              <div className="col-essy-lg-8 col-essy-md-12">
                <div className="footer-nav">
                  <h4>Services</h4>
                  <div className="row-essy">
                    <div className="col-essy-lg-4 col-essy-md-4">
                      <div className="footer_nav--items">
                        <Link>Product Demonstrations</Link>
                        <Link>Pre-Sales Support</Link>
                        <Link>Solution Customization</Link>
                        <Link>Technical Presentations </Link>
                        <Link>Technical Documentation</Link>
                        <Link>Proposal Development</Link>
                      </div>
                    </div>
                    <div className="col-essy-lg-4 col-essy-md-4">
                      <div className="footer_nav--items">
                        <Link>Troubleshooting and Resolution</Link>
                        <Link>Market Analysis</Link>
                        <Link>Customer Assessment</Link>
                        <Link>System Testing Validation</Link>
                        <Link>Feedback Collection</Link>
                        <Link>Market Analysis</Link>
                      </div>
                    </div>
                    <div className="col-essy-lg-4 col-essy-md-4">
                      <div className="footer_nav--items">
                        <Link>Competitor Analysis</Link>
                        <Link>Installation Support</Link>
                        <Link>Client Onboarding</Link>
                        <Link>Sales Strategy Development</Link>
                        <Link>Proof of Concept (PoC) Creation</Link>
                        <Link>Technical Sales Enablement</Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="separator"></div>
        <div className="copyright-wrapper">
          <div className="container">
            <div className="row-essy">
              <div className="col-essy-lg-6 col-essy-md-12">
                <div className="copyright-p">
                  <p>Copyright © 2010-2024 essy All rights reserved.</p>
                </div>
              </div>
              <div className="col-essy-lg-6 col-essy-md-12">
                <div className="footer-nav-menu">
                  <Link to="/">Home</Link>
                  <Link to="about-us">About Us</Link>
                  <Link to="faq">FAQ</Link>
                  <Link to="support">Support</Link>
                  {!token && (
                    <>
                      <Link>Login</Link>
                      <Link>Register</Link>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
